const TASA_IGV_DEFAULT = 0.18;

/**
 * Calcula subtotal, igv y total a partir del monto base (costo) y el flag incluye_igv.
 */
export function calcularMontosServicio(costo, incluyeIgv = true, tasaIgv = TASA_IGV_DEFAULT) {
  const monto = parseFloat(costo) || 0;

  if (monto <= 0) {
    return { subtotal: 0, igv: 0, total: 0, tasa_igv: tasaIgv };
  }

  if (incluyeIgv) {
    const total = Math.round(monto * 100) / 100;
    const subtotal = Math.round((monto / (1 + tasaIgv)) * 100) / 100;
    const igv = Math.round((total - subtotal) * 100) / 100;
    return { subtotal, igv, total, tasa_igv: tasaIgv };
  }

  const subtotal = Math.round(monto * 100) / 100;
  const igv = Math.round(monto * tasaIgv * 100) / 100;
  const total = Math.round((subtotal + igv) * 100) / 100;
  return { subtotal, igv, total, tasa_igv: tasaIgv };
}

/**
 * Obtiene montos desde un registro de servicio (usa columnas persistidas o calcula fallback).
 */
export function getMontosDesdeServicio(item) {
  if (item?.subtotal != null && item?.total != null) {
    return {
      subtotal: parseFloat(item.subtotal) || 0,
      igv: parseFloat(item.igv) || 0,
      total: parseFloat(item.total) || 0,
      tasa_igv: parseFloat(item.tasa_igv) || TASA_IGV_DEFAULT,
    };
  }

  const incluyeIgv = item?.incluye_igv !== 0 && item?.incluye_igv !== false && item?.incluye_igv !== '0';
  const tasaIgv = parseFloat(item?.tasa_igv) || TASA_IGV_DEFAULT;
  return calcularMontosServicio(item?.costo, incluyeIgv, tasaIgv);
}

export function parseIncluyeIgv(value) {
  if (value === undefined || value === null || value === '') {
    return true;
  }
  return value !== 0 && value !== false && value !== '0';
}
